import PropTypes from 'prop-types';

export const LOGIN_STATE = {
    LoggedOut: 0,
    SoftLoggedIn: 1,
    LoggedIn: 2,
};

export const USER_TYPE = {
    Patient: 0,
    Provider: 1,
    ZdEmployee: 2,
    BookingAgent: 9,
};

export const NOTIFICATION_TYPE = {
    ZocdocMessage: 'zocdocmessage',
    AppointmentConfirmed: 'appointmentconfirmed',
    AppointmentRescheduled: 'appointmentrescheduled',
    AppointmentCancelled: 'appointmentcancelled',
    AppointmentInfoNeeded: 'appointmentinfoneeded',
    AppointmentCheckIn: 'appointmentcheckin',
    AppointmentFeedback: 'appointmentfeedback',
    AppointmentAsyncBookingFailure: 'appointmentasyncbookingfailure',
};

export const STATE_KEYS = {
    User: 'user',
    LoginState: 'login_state',
    Notifications: 'notifications',
    UnseenNotificationCount: 'unseen_notification_count',
    UpcomingAppointments: 'upcoming_appointments',
    UserType: 'user_type',
};

export const UserAccountPropTypes = {
    loginState: PropTypes.oneOf(Object.values(LOGIN_STATE)),
    userType: PropTypes.oneOf(Object.values(USER_TYPE)),
};
